import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=e6b51964&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=e6b51964&prod&lang=scss"
import style1 from "./Chat.vue?vue&type=style&index=1&id=e6b51964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b51964",
  null
  
)

export default component.exports